import { render, staticRenderFns } from "./IntercambiarCodigos.vue?vue&type=template&id=56f84210&scoped=true"
import script from "./IntercambiarCodigos.vue?vue&type=script&lang=js"
export * from "./IntercambiarCodigos.vue?vue&type=script&lang=js"
import style0 from "./IntercambiarCodigos.vue?vue&type=style&index=0&id=56f84210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f84210",
  null
  
)

export default component.exports